var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"role menu"},[_c('span',{staticClass:"data-date"},[_vm._v(_vm._s(_vm.currentDay)+" ")]),_c('span',{staticClass:"data-minute"},[_vm._v(_vm._s(_vm.currentTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }